// extracted by mini-css-extract-plugin
export default {"AnimatedLogo":"AnimatedLogo_AnimatedLogo__64189"};